<div class="nova-font-style padding-15">
  <h2>Person Information</h2>
  <div kendoTooltip class="top-margin-15 form-control">
    <p class="headingrow"><span class="bold headingtext">Employee Details</span></p>
    <div class="row top-margin-15">
      <div class="col s12 m3 l2 xl2">
        <span class="bold">Employee SSN:</span>
      </div>
      <div class="col s8 m3 l2 xl2">
        <kendo-maskedtextbox id="ssn" [mask]="ssnMask" (valueChange)="onSsnChange($event)" [value]="value">
        </kendo-maskedtextbox>
        <div class="top-margin-1">
          <span class="tooltip-validation left-margin-0" *ngIf="validSSNMsg">
            Valid SSN is required
          </span>
        </div>
      </div>
      <div class="col s4 m2 l2 xl2">
        <button type="submit" id="search-btn" class="btn background-red" (click)="employmentInfoSearch(false, false)"
          [disabled]="searchBtnEnable || isProcessing">
          <span *ngIf="!isProcessing" class="k-icon k-i-search"></span>
          <span *ngIf="isProcessing" class="k-icon k-i-loading inner"></span>
        </button>
      </div>
    </div>
    <div class="text-red" *ngIf="isRecordAlreadyFatched">
      <span class="k-icon k-i-warning"></span>{{config.RecordAlreadyFatchedMsg}}
    </div>
    <div class="row" *ngIf="isPersonInfoVisible">
      <form [formGroup]="personForm">
        <div class="row">
          <div class="col s12 m12 l12 xl12 top-margin-15 left-padding-0">
            <div class="form-group">
              <div class="col s12 m3 l3 xl3">
                <label for="ssn" class="control-label bold right-margin-10">SSN: </label>
                <kendo-maskedtextbox class="ssn-input input-auto-width" id="ssn" [mask]="ssnMask" formControlName="ssn">
                </kendo-maskedtextbox>
              </div>
              <div class="col s12 m3 l3 xl3">
                <label for="firstName" class="control-label bold">First Name<span class="k-required">*</span>: </label>
                <input class="input-auto-width custom-width-56p custom-width-auto" type="text" id="firstName"
                  maxlength="12" formControlName="firstName" (input)="isFormTouched()">
                <div class="top-margin-1">
                  <span class="tooltip-validation left-margin-0"
                    *ngIf="personForm.controls.firstName.touched && personForm.controls.firstName.errors">
                    Valid First Name is required
                  </span>
                </div>
              </div>
              <div class="col s12 m3 l3 xl3">
                <label for="MI" class="control-label bold">MI: </label>
                <input class="input-auto-width" type="text" id="MI" maxlength="1" formControlName="MI"
                  (input)="isFormTouched()">
              </div>
              <div class="col s12 m3 l3 xl3">
                <label for="lastName" class="control-label bold">Last Name<span class="k-required">*</span>: </label>
                <input class="input-auto-width custom-width-56p custom-width-auto" type="text" id="lastName"
                  maxlength="17" formControlName="lastName" (input)="isFormTouched()">
                <div class="top-margin-1">
                  <span class="tooltip-validation left-margin-0"
                    *ngIf="personForm.controls.lastName.touched && personForm.controls.lastName.errors">
                    Valid Last Name is required
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col s12 m12 l12 xl12 top-margin-15 left-padding-0">
            <div class="form-group">
              <div class="col s12 m3 l3 xl3" id="dob">
                <label for="dateOfBirth" class="control-label bold">DOB<span class="k-required">*</span>:
                </label>
                <kendo-datepicker id="dateOfBirth" format="MM/dd/yyyy"
                  class="textbox data-selector auto-width width-100p input-auto-width" formControlName="dateOfBirth"
                  placeholder="mm/dd/yyyy" (valueChange)="isFormTouched()">
                </kendo-datepicker>
                <div class="top-margin-1"
                  *ngIf="personForm.get('dateOfBirth').invalid && personForm.get('dateOfBirth').touched">
                  <div class="tooltip-validation left-margin-0" *ngIf="personForm.get('dateOfBirth').errors?.required">
                    Date of Birth is required</div>
                  <div class="tooltip-validation left-margin-0"
                    *ngIf="personForm.get('dateOfBirth').errors?.invalidAge">Age must be between 16 and 100</div>
                </div>
              </div>
              <div class="col s12 m3 l3 xl3" id="gender-dropdown">
                <label for="gender" class="control-label bold right-margin-15">Gender<span class="k-required">*</span>:
                </label>
                <kendo-dropdownlist [defaultItem]="defaultItem" id="gender" [data]="gendersData"
                  class="width-100p input-auto-width" [textField]="'name'" [valueField]="'code'"
                  formControlName="gender" [valuePrimitive]="true" (selectionChange)="selectionChange(true)">
                </kendo-dropdownlist>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- Retiree Questions -->
      <div class="top-margin-5 inline-flex-display" *ngIf="isRetireeInfoVisible"
        (change)='onRetireeEnrolledInfoChange()'>
        <div class="left-padding-0">
          <span class="bold">{{config.RetireeQuestion}}</span>
        </div>
        <div class="left-padding-10 inline-flex-display">
          <input type="radio" id="yesRadio" [(ngModel)]="isLegislativePlan" [value]="true" name="isLegislativePlan"
            kendoRadioButton />
          <label class="k-radio-label left-margin-0 right-margin-10" id="enrolled-text" for="yesRadio">Yes</label>
          <input type="radio" id="noRadio" [(ngModel)]="isLegislativePlan" [value]="false" name="isLegislativePlan"
            kendoRadioButton />
          <label class="k-radio-label left-margin-0" id="enrolled-text" for="noRadio">No</label>
        </div>
      </div>
      <div class="top-margin-15" *ngIf="isNoLegislativeEnrolledSelected">
        <div class="left-padding-0">
          <span class="text-red">{{config.RetireeNoSelectionMsg}}</span>
        </div>
      </div>
      <div class="stroke-separator"></div>
      <div class="row top-margin-15">
        <div class="col s12 m12 l6 xl6" *ngIf="!isRecordAlreadyFatched">
          <button type="button" (click)="exitForm()" class="btn btn-fullwidth background-red">
            Reset Form
          </button>
        </div>
        <div class="col s12 m12 l6 xl6 align-right" *ngIf="!isNoLegislativeEnrolledSelected">
          <button type="submit" (click)="next(1)" class="btn btn-fullwidth background-red"
            [disabled]="personForm.invalid || displayload || (isRetireeInfoVisible ? (isLegislativePlan === null || isLegislativePlan === false) : false)">
            <span *ngIf="!displayload">Save and Continue</span>
            <span *ngIf="displayload" class="k-icon k-i-loading inner"></span>
            <span *ngIf="!displayload" class="k-icon k-i-arrow-chevron-right"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>